import { apiRequest } from "../util/apiUtils";

export const emailTemplateList = async (params) => {
  try {
    const res = await apiRequest("get", `email-template/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const emailDetails = async (params) => {
  try {
    const res = await apiRequest("get", `email-template/backend/detail/${params?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const emailTemplateAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `email-template/backend/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const emailTemplateStatusChange = async (payload) => {
  try {
    const res = await apiRequest("put", `email-template/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
